import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { IconButton } from "@mui/joy";
import { useParams } from 'react-router-dom';
import { useAddFavoriteMutation, useRemoveFavoriteMutation } from '../favoritesApi';

export function FavoriteButton({ recipeId, isFavorite, sx = {} }) {
  const { householdId } = useParams();
  const [addFavorite] = useAddFavoriteMutation();
  const [removeFavorite] = useRemoveFavoriteMutation();

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isFavorite) {
      removeFavorite({ householdId, recipeId });
    } else {
      addFavorite({ householdId, recipeId });
    }
  };

  return (
    <IconButton
      onClick={handleToggle}           
      variant="soft"      
      sx={{ 
        "--IconButton-size": "21px",
        "--Icon-fontSize": "15px",
        borderRadius: '50%',                 
        backgroundColor: 'rgba(255, 255, 255, 0.92)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 1)',
        },        
        width: '21px !important',
        height: '21px !important',
        ...sx 
      }}
    >
      {isFavorite ? (
        <FavoriteIcon sx={{ color: '#e53935' }} />
      ) : (
        <FavoriteBorderIcon sx={{ color: 'neutral.600' }} />
      )}
    </IconButton>
  );
}

